import type { Ref } from 'react';
import type { InteractiveAtomSize } from '../utils/InteractiveAtomProps';

export type RadioValue = boolean;
export type RadioState = 'checked' | 'unchecked';
export type RadioSize = InteractiveAtomSize;

export type RadioProps = {
  value: RadioValue;
  size?: RadioSize;
  // if onChange is undefined, the radio is not interactive (i.e. readonly) and renders as a div
  onChange?: (value: boolean) => void;
  className?: string;
  disabled?: boolean;
  hasError?: boolean;
  innerRef?: Ref<HTMLButtonElement | HTMLDivElement>;
};

export function fromValueToState(value: RadioValue): RadioState {
  return value ? 'checked' : 'unchecked';
}
